import React from 'react';
import {PFooter, PTop, PTopWrapper} from './styles';
import {useInputValue} from '../../../utils/hooks/useInputValue';
import {InputComponent, Label, LargeButton, TextWarning} from '../../../components';
import {Auth} from '../../../utils/api';

export default ({handleView}: {handleView: any}) => {
  const PasswordInput1 = useInputValue('', 'eyeClose', '', '', 'password');
  const PasswordInput2 = useInputValue('', 'eyeClose', '', '', 'password');
  const PasswordInput3 = useInputValue('', 'eyeClose', '', '', 'password');

  function HandleIcon(e: any) {
    if (e === '1') {
      AlternateIcon(PasswordInput1);
    } else if (e === '2') {
      AlternateIcon(PasswordInput2);
    } else if (e === '3') {
      AlternateIcon(PasswordInput3);
    }
  }

  async function HandleSubmit() {
    let err = 0;
    if (!Boolean(PasswordInput1.value.length)) {
      PasswordInput1.HandleWarning('This field cannot be empty');
      PasswordInput1.HandleStatus('error');
      err++;
    }
    if (!Boolean(PasswordInput2.value.length)) {
      PasswordInput2.HandleWarning('This field cannot be empty');
      PasswordInput2.HandleStatus('error');
      err++;
    }
    if (!Boolean(PasswordInput3.value.length)) {
      PasswordInput3.HandleWarning('This field cannot be empty');
      PasswordInput3.HandleStatus('error');
      err++;
    }
    if (PasswordInput2.value !== PasswordInput3.value) {
      PasswordInput3.HandleWarning('Passwords do not match');
      PasswordInput3.HandleStatus('error');
      err++;
    } else if (err === 0) {
      const AUTH = new Auth();
      const response: any = await AUTH.ChangePassword(PasswordInput1.value, PasswordInput2.value, PasswordInput3.value);
      if (response.status) {
        handleView(false);
      } else {
        PasswordInput1.HandleWarning('invalid Password');
        PasswordInput1.HandleStatus('error');
      }
    }
  }

  function HandleFocus(e: any) {
    if (e === '1') {
      AlternateFocus(PasswordInput1);
    } else if (e === '2') {
      AlternateFocus(PasswordInput2);
    } else if (e === '3') {
      AlternateFocus(PasswordInput3);
    }
  }

  function AlternateIcon(hook: any) {
    if (hook.icon === 'eyeClose') {
      hook.HandleIcon('eyeOpen');
      hook.HandleType('text');
    } else if (hook.icon === 'eyeOpen') {
      hook.HandleIcon('eyeClose');
      hook.HandleType('password');
    }
  }

  function AlternateFocus(hook: any) {
    hook.HandleStatus('normal');
    hook.HandleWarning('');
  }

  return (
    <form>
      <PTop>
        <PTopWrapper>
          <Label text="Old Password" />
          <div data-cy="old-pw">
            <InputComponent
              idKey="1"
              placeholder="*****"
              animateWidth="100%"
              dynamicSearch={PasswordInput1}
              HandleIcon={HandleIcon}
              HandleFocus={HandleFocus}
            />
            <TextWarning status={PasswordInput1.status} message={PasswordInput1.warningMessage} />
          </div>
        </PTopWrapper>
        <PTopWrapper>
          <Label text="New password" />
          <div data-cy="new-pw">
            <InputComponent
              idKey="2"
              placeholder="*****"
              animateWidth="100%"
              dynamicSearch={PasswordInput2}
              HandleIcon={HandleIcon}
              HandleFocus={HandleFocus}
            />
            <TextWarning status={PasswordInput2.status} message={PasswordInput2.warningMessage} />
          </div>
        </PTopWrapper>
        <PTopWrapper>
          <Label text="Repeat new password" />
          <div data-cy="rnew-pw">
            <InputComponent
              idKey="3"
              placeholder="*****"
              animateWidth="100%"
              dynamicSearch={PasswordInput3}
              HandleIcon={HandleIcon}
              HandleFocus={HandleFocus}
            />
            <TextWarning status={PasswordInput3.status} message={PasswordInput3.warningMessage} />
          </div>
        </PTopWrapper>
      </PTop>
      <PFooter>
        <LargeButton
          callback={() => handleView(false)}
          rColor="#ffffff"
          lColor="#ffffff"
          title="CANCEL"
          fColor="#5D6C76"
          bColor="#F0F0F0"
          lMargin="0"
          rMargin="0 40px"
          xMargin="0 10px 0 0"
        />
        <LargeButton
          callback={HandleSubmit}
          rColor="#006BE1"
          lColor="#006BE1"
          lMargin="0"
          rMargin="0 60px"
          fullWidth
          bColor="#006BE1"
          title="CHANGE"
        />
      </PFooter>
    </form>
  );
};
